import { render, staticRenderFns } from "./errorMessageAuth.vue?vue&type=template&id=a5fba986"
import script from "./errorMessageAuth.vue?vue&type=script&lang=js"
export * from "./errorMessageAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports